import { render, staticRenderFns } from "./subMenuForm.vue?vue&type=template&id=71b8a2a4&scoped=true&"
import script from "./subMenuForm.vue?vue&type=script&lang=js&"
export * from "./subMenuForm.vue?vue&type=script&lang=js&"
import style0 from "./subMenuForm.vue?vue&type=style&index=0&id=71b8a2a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8a2a4",
  null
  
)

export default component.exports